import React from "react";
import Button from "../Button";
import { connect } from "react-redux";
import { push } from "redux-little-router";
import PropTypes from "prop-types";

const LinkButton = ({ href, redirect, ...rest }) => <Button {...rest} onClick={() => redirect(href)} />;

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => ({
  redirect: href => dispatch(push(href)),
});
export default connect(null, mapDispatchToProps)(LinkButton);



// WEBPACK FOOTER //
// ./src/components/LinkButton/index.js